import { getCurrentInstance } from "vue";

export function useRoutes() {
    const vm = getCurrentInstance()
    return vm.appContext.config.globalProperties.$routes
}